import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step727745Meta extends BaseModel {
  /**
   * @var {string}
   */
  assetFamiliarityType;

  /**
   * @var {string}
   */
  paperworkFamiliarityType;

  /**
   * @var {string}
   */
  employmentHistoryFamiliarityType;

  /**
   * @var {string}
   */
  employmentType;

  constructor(model = {}) {
    super();
    this.assetFamiliarityType = model.assetFamiliarityType;
    this.paperworkFamiliarityType = model.paperworkFamiliarityType;
    this.employmentHistoryFamiliarityType = model.employmentHistoryFamiliarityType;
    this.employmentType = model.employmentType;
  }
}
